import { APP_ENV } from '@/common/const/env.const'

export const APP_CONFIG = {
  [APP_ENV.development]: {
    API: '',
    SENTRY: ''
  },
  [APP_ENV.production]: {
    API: '',
    SENTRY: ''
  }
}
